<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
      <!-- Profile Card -->
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8 flex flex-col items-center sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
        
        <!-- Profile Information -->
        <div class="flex flex-col items-center sm:items-start sm:flex-row sm:space-x-4">
          <img :src="profilePicture" alt="Profile Picture" class="w-24 h-24 rounded-full shadow-md object-cover mb-4 sm:mb-0">
          <div class="text-center sm:text-left">
            <h2 class="text-xl sm:text-2xl font-bold text-gray-800">{{ user.name }}</h2>
            <p class="text-lg text-gray-700">{{ user.email }}</p>
            <p class="text-lg text-gray-700">{{ user.phone }}</p>
          </div>
        </div>

      </div>
  
      <!-- Account Settings -->
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
        <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Account Settings</h2>
  
        <ul class="space-y-4">
          <li class="p-4 border rounded-lg shadow-sm bg-gray-50">
            <div class="flex justify-between items-center">
              <span class="text-gray-700">Change Password</span>
              <button @click="changePassword" 
                      class="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
                Change
              </button>
            </div>
          </li>
          <li class="p-4 border rounded-lg shadow-sm bg-gray-50">
            <div class="flex justify-between items-center">
              <span class="text-gray-700">Update Email</span>
              <button @click="updateEmail" 
                      class="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
                Update
              </button>
            </div>
          </li>
          <li class="p-4 border rounded-lg shadow-sm bg-gray-50">
            <div class="flex justify-between items-center">
              <span class="text-gray-700">Update Phone</span>
              <button @click="updateEmail" 
                      class="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
                Update
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
import { mapState } from 'vuex';

  export default {
    data() {
      return {
    
        profilePicture: 'https://via.placeholder.com/150' // Placeholder for profile picture
      };
    },
    computed : {
        ...mapState('auth', {
            user : state => state.user,
        })
    },
    methods: {
      editProfile() {
        // Logic for editing profile
        alert('Edit profile clicked');
      },
      changePassword() {
        // Logic for changing password
        alert('Change password clicked');
      },
      updateEmail() {
        // Logic for updating email
        alert('Update email clicked');
      },
      deleteAccount() {
        // Logic for deleting account
        if (confirm('Are you sure you want to delete your account?')) {
          alert('Account deleted');
        }
      }
    }
  };
  </script>
  